import dayjs from 'dayjs'

import {
  LAST_12_MONTHS,
  LAST_24_MONTHS,
  LAST_30_DAYS,
  LAST_36_MONTHS,
  LAST_3_MONTHS,
  LAST_6_MONTHS,
  LAST_7_DAYS,
} from 'consts/filterOptions'

const TODAY = dayjs()

export const UPLOAD_DATE_OPTIONS = [
  {
    label: 'Last 24 hours',
    value: '24h',
    key: '24h',
    filterName: 'Period',
    start: dayjs().subtract(1, 'day'),
    end: TODAY,
    rangeQuery: { gte: dayjs().subtract(24, 'hour').valueOf() },
  },
  {
    label: 'Last 7 days',
    value: '7d',
    key: '0',
    filterName: 'Period',
    start: dayjs().subtract(1, 'week'),
    end: TODAY,
    rangeQuery: { gte: LAST_7_DAYS },
  },
  {
    label: 'Last 30 days',
    value: 1,
    key: '1',
    filterName: 'Period',
    start: dayjs().subtract(1, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_30_DAYS },
  },
  {
    label: 'Last 3 months',
    value: 3,
    key: '3',
    filterName: 'Period',
    start: dayjs().subtract(3, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_3_MONTHS },
  },
  {
    label: 'Last 6 months',
    value: 6,
    key: '6',
    filterName: 'Period',
    start: dayjs().subtract(6, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_6_MONTHS },
  },
  {
    label: 'Last 12 months',
    value: 12,
    key: '12',
    filterName: 'Period',
    start: dayjs().subtract(12, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_12_MONTHS },
  },
  {
    label: 'Last 2 years',
    value: 24,
    key: '24',
    filterName: 'Period',
    start: dayjs().subtract(24, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_24_MONTHS },
  },
  {
    label: 'Last 3 years',
    value: 36,
    key: '36',
    filterName: 'Period',
    start: dayjs().subtract(36, 'month'),
    end: TODAY,
    rangeQuery: { gte: LAST_36_MONTHS },
  },
  // Leaving this option here in case we need to re-enable it in the future
  // {
  //   label: 'Last 5 years',
  //   value: 61,
  //   key: '61',
  //   filterName: 'Period',
  //   start: dayjs().subtract(61, 'month'),
  //   end: TODAY,
  //   rangeQuery: { gte: LAST_61_MONTHS },
  // },
  {
    //IMPORTANT! always leave the custom option as the last of the array
    label: 'Custom',
    value: function (gteValue, lteValue) {
      return `custom_${gteValue}_${lteValue}`
    },
    staticValue: window.location.search,
    key: 'custom',
    filterName: 'Period',
    rangeQuery: function (gteValue, lteValue) {
      return { gte: +gteValue, lte: +lteValue }
    },
  },
]
